import applyJsonLogic from './jsonLogic';

type WithChildren<T extends {}> = T & {
  children: T[];
};

const useHierarchyFilter = <T extends {}>(data: WithChildren<T>, filters: Array<any>) => {
  const filtersCount = filters.length;

  if (filtersCount === 0) return data;

  const mapChildrenItems =
    (map: any) =>
    (item: WithChildren<T>): WithChildren<T>[] => {
      return item.children?.length > 0 ? item.children.map(map) : [];
    };

  const filterHierarchy = (item: WithChildren<T>): T | null => {
    const matchedChildren = mapChildrenItems(filterHierarchy)(item);
    const filtered = matchedChildren.filter(kid => !!kid);
    if (applyJsonLogic(item, filters).length === filtersCount || filtered.length > 0) {
      return { ...item, children: filtered };
    }
    return null;
  };

  return filterHierarchy(data) || { ...data, children: [] };
};

export default useHierarchyFilter;
